






















import Vue from 'vue'
import Global from '@/js/global.js'
import ScrollFire from '@/views/mixin/ScrollFire'
import GrayArrowButton from '@/views/atoms/GrayArrowButton.vue'
import PopupLastQuiz from '@/views/templates/tenugui/PopupLastQuiz.vue'
import FooterBuyArea from '@/views/molecules/FooterBuyArea.vue'
import ReshowQuiz from '@/views/atoms/ReshowQuiz'

Vue.mixin(ScrollFire)

export default
  components: {
    GrayArrowButton
    FooterBuyArea
    PopupLastQuiz
    ReshowQuiz
  }

  created: () ->
    @$options.scroll_target = '.finish_view'

  data: () ->
    showPopup: 0
    fire_scroll: true

  mounted: () ->
    requestAnimationFrame(() =>
      window.addEventListener('scroll', @_onScroll)
    )

  destroyed: () ->
    window.removeEventListener('scroll', @_onScroll)

  methods: {
    _onScroll: (e) ->
      wk = document.querySelector('.finish_view').offsetTop - window.scrollY
      if wk < 0
        return
      if wk - window.innerHeight <= 0
        @$emit('scrollFire')
        result = await Global.checkPointHit('p2-18')
        if result
          return
        if @showPopup == 0
          @showPopup = 1
    reshow_quiz: () ->
      @showPopup = 1
    close_popup: (mode) ->
      @showPopup = mode
    add_point: (point) ->
      @$emit('addPoint', point)
  }
